// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface StopIconSignature {
  Element: SVGSVGElement;
}

export const StopIcon: TOC<StopIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5 3H19C20.103 3 21 3.896 21 5V19C21 20.103 20.103 21 19 21H5C3.897 21 3 20.103 3 19V5C3 3.896 3.897 3 5 3ZM5 5V19H19.001L19 5H5Z"/>
</svg>
</template>;